import React from 'react'
import { ROUTES } from '../../shared/constants'
import CustomViewForm from '../CustomViewForm'
import HeaderTabLayout from '../HeaderTabLayout'
import Layout from '../Layout'
import Loader from '../Loader'

export default function CustomViewPage({ loading, heading, redirect, data, id, editUrl }) {
  return (
    <Layout heading={heading} heading2="Info" url1={ROUTES[redirect]} none>
      {!loading ? <HeaderTabLayout 
      heading={heading} content={<CustomViewForm data={data} />} view url={`/edit-${editUrl}/${id}`} /> : <Loader />}
    </Layout>
  )
}
